<template lang="pug">
	a.tiptap-file-download(:href="href", target="_blank", rel="noopener")
		span.label {{ label }}
		//- O espaço separa rótulo e tipo no nome acessível do link
		span.meta(v-if="meta") {{ ` ${meta}` }}
</template>

<script>
export default {
	name: 'component-tiptap-file-download',
	props: {
		href: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			default: 'Baixar arquivo',
		},
		meta: {
			type: String,
			default: '',
		},
	},
}
</script>

<style lang="stylus" scoped src="./FileDownload.styl"></style>
